module.exports = __webpack_public_path__ + "img/group-logo-black.08565937.svg";